
const calculateBearing = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const y = Math.sin(lng2 - lng1) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1);
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
};

export const getStreetViewUrl = async (address: string, apiKey: string): Promise<string | null> => {
  try {
    // Geocode address
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;
    const geocodeRes = await fetch(geocodeUrl);
    const geocodeData = await geocodeRes.json();
    
    if (geocodeData.status !== "OK") return null;
    
    const { lat: targetLat, lng: targetLng } = geocodeData.results[0].geometry.location;
    
    // Get Street View metadata
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${targetLat},${targetLng}&radius=50&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();
    
    if (metadataData.status !== "OK") return null;
    
    const { lat: panoLat, lng: panoLng } = metadataData.location;
    const heading = calculateBearing(panoLat, panoLng, targetLat, targetLng);
    
    // Return Street View image URL
    return `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${heading.toFixed(2)}&pitch=0&fov=90&key=${apiKey}`;
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlFromCoords = async (lat: number, lng: number, apiKey: string): Promise<string | null> => {
  try {
    // Get Street View metadata
    console.log('getting street view url from coords', lat, lng);
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&radius=10&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();
    
    if (metadataData.status !== "OK") return null;
    
    const { lat: panoLat, lng: panoLng } = metadataData.location;
    const heading = calculateBearing(panoLat, panoLng, lat, lng);
    
    // Return Street View image URL
    return `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${heading.toFixed(2)}&pitch=0&fov=90&key=${apiKey}`;
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlFromAddress = async (address: string, lat: number, lon: number, apiKey: string): Promise<string | null> => {
  try {

    // Get Street View metadata
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${address}&radius=50&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();

    if (metadataData.status !== "OK" || !metadataData.location) return null;

    const { lat: panoLat, lng: panoLng } = metadataData.location;
    // Calculate heading from pano location to target location
    const heading = calculateBearing(panoLat, panoLng, lat, lon);

    // Return Street View image URL
    return `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${heading.toFixed(2)}&pitch=0&source=outdoor&fov=100&key=${apiKey}`;
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlsFromCoords = async (lat: number, lng: number, apiKey: string): Promise<string[] | null> => {
  try {
    // Get Street View metadata
    console.log('getting street view urls from coords', lat, lng);
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&radius=10&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();
    
    if (metadataData.status !== "OK") return null;
    
    const { lat: panoLat, lng: panoLng } = metadataData.location;
    
    // Return four Street View image URLs with different angles (0, 90, 180, 270 degrees)
    const angles = [0, 90, 180, 270];
    return angles.map(angle => 
      `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${angle}&pitch=0&fov=90&key=${apiKey}`
    );
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlsFromAddress = async (address: string, lat: number, lon: number, apiKey: string): Promise<string[] | null> => {
  try {
    // Get Street View metadata
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${address}&radius=50&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();

    if (metadataData.status !== "OK" || !metadataData.location) return null;

    const { lat: panoLat, lng: panoLng } = metadataData.location;
    
    // Return four Street View image URLs with different angles (0, 90, 180, 270 degrees)
    const angles = [0, 90, 180, 270];
    return angles.map(angle => 
      `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${angle}&pitch=0&source=outdoor&fov=100&key=${apiKey}`
    );
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

